import React from 'react'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

import { Icon } from './styles'

export function DaysTitleTooltipHint() {
  const { t } = useTranslation()

  return (
    <Tooltip
      title={
        <>
          {t('web.policies.rules.hint.days-message1')}
          <br />
          {t('web.policies.rules.hint.days-message2')}
        </>
      }
    >
      <Icon theme="twoTone" twoToneColor="#1890ff" type="info-circle" />
    </Tooltip>
  )
}
